"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowStats = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var api_1 = require("../api");
var ProfileIcon_1 = require("./ProfileIcon");
var ShowStats = function () {
    var _a = (0, react_1.useState)(), stats = _a[0], setStats = _a[1];
    (0, react_1.useEffect)(function () {
        (0, api_1.fetchStats)().then(function (nextStats) {
            if (nextStats)
                setStats(nextStats);
        });
    }, []);
    if (!stats)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Statistic.Group, { size: "tiny", children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Statistic, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Statistic.Label, { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "profile" }), i18n_1.default.profileCount] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Statistic.Value, { children: stats.profileCount })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Statistic, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Statistic.Label, { children: [(0, jsx_runtime_1.jsx)(ProfileIcon_1.ProfileIcon, { iconFor: "privateMemo" }), i18n_1.default.memoUserCount] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Statistic.Value, { children: stats.memoUserCount })] })] }));
};
exports.ShowStats = ShowStats;
